export function convertEnumToArray(EnumValues: any ) {
  const keys = Object.keys(EnumValues);
  let enumArray: any[] = [];
  keys.forEach(key => {
    enumArray.push(EnumValues[key]);
  });
  return enumArray;
}
